module.exports = {"513424001":"德州街道","513424002":"昌州街道","513424101":"永郎镇","513424102":"乐跃镇","513424103":"麻栗镇","513424106":"茨达镇","513424109":"巴洞镇","513424113":"黑龙潭镇","513424114":"铁炉镇","513424115":"热河镇","513424217":"南山傈僳族乡","513424218":"金沙傈僳族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513424.json
// module id = 2565
// module chunks = 0